import { gql } from '@apollo/client';

export const GET_ACCOUNT_BALANCE_CSV = gql`
  query accountBalanceCSV($input: AccountBalanceInputV2!) {
    accountBalanceCSV(input: $input) {
      csv
    }
  }
`;
